import DurationService from "app/services/DurationService";
import { swSettings } from "app/common/services/swSettings";
import dayjs from "dayjs";

export const journeyTransitionRedirect = (trans: any) => {
    const { country, duration } = trans.params();
    const durationObj = DurationService.getDurationData(duration, undefined);
    const monthDiff = DurationService.diffByUnit(durationObj.raw.from, durationObj.raw.to, "months");
    const toComponent = swSettings.components[trans.to().configId];
    const newCountry =
        toComponent.allowedCountries.length > 0 &&
        toComponent.allowedCountries.filter((item) => item.id === toComponent.defaultParams.country).length > 0
            ? toComponent.defaultParams.country
            : toComponent.allowedCountries[0].id;
    if (country === "999") {
        return {
            params: { ...trans.params(), country: newCountry },
        };
    }
    if (monthDiff > 2 || durationObj.raw.from.isBefore(dayjs.utc(toComponent.resources.SupportedInterval.startdate))) {
        return {
            params: { ...trans.params(), duration: "3m" },
        };
    }
};
